module.exports = __webpack_public_path__ + "media/components/common/loader/loader-61d6454ef740b1929bd6f83215982d12.svg";